<template>
  <div class="row">
    <div class="col-md-12">
      <a name="availability"></a>
      <div class="row">
        <div class="col-md-12">
          <div class="item-lead">
            <div class="enterprise-lead-head">Book Your Stay</div>
            <div class="item-sub">
              <div class="item-sub-line"></div>
              <div class="item-sub-text">
                <i class="fa fa-bookmark more-solutions-icon" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="calendar">
            <iframe
              src="https://calendar.google.com/calendar/embed?src=hunorafamilycabin%40gmail.com&ctz=America%2FDenver"
              style="border: 0"
              width="800"
              height="600"
              frameborder="0"
              scrolling="no"
            ></iframe>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-8 col-md-offset-2">
          <div class="contact-form">
            <form id="contact-icm" class="hunora-form" @submit.prevent="handleSubmit">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">Name</label>
                    <input
                      type="text"
                      id="name"
                      class="form-control"
                      v-model="submission.name"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">Email</label>
                    <input
                      type="email"
                      id="email"
                      class="form-control"
                      v-model="submission.email"
                      required
                    />
                    <input
                      type="text"
                      id="gotcha"
                      name="_gotcha"
                      v-model="gotcha"
                      style="display:none"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">Dates of Stay</label>
                    <v-date-picker mode="range" v-model="submission.dates" :min-date="new Date()">
                      <!--Custom Input Slot-->
                      <input
                        id="date"
                        type="input"
                        slot-scope="{ inputProps, inputEvents }"
                        :class="[`form-control date-picker`]"
                        readonly
                        v-bind="inputProps"
                        v-on="inputEvents"
                      />
                    </v-date-picker>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      placeholder="(xxx) xxx-xxxx"
                      class="form-control"
                      v-model="submission.phone"
                      v-mask="'(###) ###-####'"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Message</label>
                    <textarea
                      name="message"
                      id="message"
                      cols="40"
                      rows="5"
                      class="form-control"
                      v-model="message"
                      maxlength="300"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button class="btn btn-teal" type="submit" :disabled="success">Submit Reservation</button>
                </div>
                <div class="col-md-12">
                  <div class="has-success" v-if="success">Your submission was successful.</div>
                  <div
                    class="has-error"
                    v-if="error"
                  >Oops, looks like there was an unexpected error with your submission.</div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import moment from 'moment';
  import { mask } from 'vue-the-mask';

  export default {
    data() {
      return {
        submission: {
          name: '',
          email: '',
          dates: null,
          phone: ''
        },
        message: '',
        gotcha: '',
        error: false,
        success: false
      };
    },
    directives: { mask },
    methods: {
      fortmatDate(date) {
        if (date != null) {
          return moment(date.toString()).format('MM/DD/YYYY');
        }
      },
      async handleSubmit() {
        if (this.submission.gotcha !== '') {
          var valid = true;
          for (const key in this.submission) {
            if (this.submission[key] === '' || this.submission[key] === null) {
              valid = false;
            }
          }
          if (valid) {
            try {
              const model = {
                Name: this.submission.name,
                Email: this.submission.email,
                Phone: this.submission.phone,
                Subject:
                  this.submission.name + ' reservation request for ' + this.fortmatDate(this.submission.dates.start),
                _subject:
                  this.submission.name + ' reservation request for ' + this.fortmatDate(this.submission.dates.start),
                Arriving: this.submission.dates.start.toDateString(),
                Leaving: this.submission.dates.end.toDateString(),
                Message: this.message
              };
              const response = await axios.post('https://formspree.io/mwkrlvel', model);
              if (response) {
                this.success = true;
              }
            } catch (err) {
              this.error = true;
            }
          }
        }
      }
    }
  };
</script>

<style>
  .control-label {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 600;
  }

  .date-picker {
    cursor: pointer;
  }

  .hunora-form {
    margin: 60px 0 0;
  }
  .has-error {
    margin: 20px 0;
    padding: 10px;
    color: #c53030;
    background-color: #fed7d7;
  }
  .has-success {
    margin: 20px 0;
    padding: 10px;
    color: #018376;
    background-color: #d9f0ed;
  }
</style>
